import React, { Component } from 'react';
import {
  EditorState,
  convertToRaw,
  ContentState,
  convertFromHTML,
} from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import { UPLOAD_CONST } from '../domain/constant';

// Custom styles for sticky header
const editorStyles = {
  wrapper: {
    position: 'relative',
  },
  editor: {
    padding: '1rem',
    minHeight: '300px',
    maxHeight: '600px',
    overflowY: 'auto',
  },
  toolbar: {
    position: 'sticky',
    top: 0,
    zIndex: 100,
    backgroundColor: '#fff',
    borderBottom: '1px solid #ddd',
  },
};

export class EditorWYSIWYG extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editorState: '',
    };
  }
  componentDidMount() {
    const html = this.props.value || '';
    const blocksFromHTML = convertFromHTML(html);

    const contentState = ContentState.createFromBlockArray(
      blocksFromHTML.contentBlocks,
      blocksFromHTML.entityMap
    );

    this.setState({
      editorState: EditorState.createWithContent(contentState),
    });
  }

  uploadImageCallBack = async (file) => {
    console.log(file);
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('POST', UPLOAD_CONST);

      const data = new FormData();
      data.append('files', file, file.name);
      xhr.send(data);
      xhr.addEventListener('load', () => {
        // console.log(xhr.responseText);
        resolve({ data: { link: xhr.responseText } });
      });
      xhr.addEventListener('error', () => {
        const error = JSON.parse(xhr.responseText);
        console.log(error);
        reject(error);
      });
    });
  };

  onEditorStateChange = (editorState) => {
    this.setState({
      editorState,
    });
    this.props.changeValue(
      draftToHtml(convertToRaw(editorState.getCurrentContent()))
    );
    console.log(draftToHtml(convertToRaw(editorState.getCurrentContent())));
  };

  render() {
    const { editorState } = this.state;
    return (
      <Editor
        editorState={editorState}
        wrapperClassName='demo-wrapper'
        editorClassName='demo-editor'
        onEditorStateChange={this.onEditorStateChange}
        stripPastedStyles={true}
        wrapperStyle={editorStyles.wrapper}
        editorStyle={editorStyles.editor}
        toolbarStyle={editorStyles.toolbar}
        toolbar={{
          options: [
            'inline',
            'blockType',
            'fontSize',
            'list',
            'textAlign',
            'colorPicker',
            'link',
            'embedded',
            'emoji',
            'image',
            'remove',
            'history',
          ],

          image: {
            uploadCallback: this.uploadImageCallBack,
          },
        }}
      />
    );
  }
}

export default EditorWYSIWYG;
